import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Button, Icon, Modal, Form,
} from 'semantic-ui-react';
import Validator from 'validatorjs';
import { isEmpty } from 'lodash';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';
import resendFlatRateOfferBatchMutation from '../../graphql/resendFlatRateOfferBatchMutation';

class ResendEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      name: '',
      errors: {},
      flatRateOfferBatchId: '',
    };
  }

  componentDidMount() {
    const { enrollmentStatus, incompleteEnrollment } = this.props;
    if (!isEmpty(enrollmentStatus) && !isEmpty(incompleteEnrollment)) {
      const { name, email } = enrollmentStatus;
      const { flatRateOfferBatchId } = incompleteEnrollment;

      this.setState({
        name,
        email,
        flatRateOfferBatchId,
      });
    }
  }

  render() {
    const {
      modalOpen,
      handleClose,
      flashMessageSuccess,
      flashMessageFailure,
    } = this.props;

    const {
      errors, name, email, flatRateOfferBatchId,
    } = this.state;

    const validationRules = {
      email: 'required|email',
    };

    const handleCloseHandler = () => {
      this.setState({
        errors: {},
        email: '',
        name: '',
        flatRateOfferBatchId: '',
      });
      handleClose();
    };

    const onChangeHandler = field => event => {
      this.setState({ [field]: event.target.value });
    };

    const submitForm = () => {
      const validation = new Validator(this.state, validationRules);
      if (validation.fails()) {
        this.setState({ errors: validation.errors.all() });
        return false;
      }
      const input = {
        id: flatRateOfferBatchId,
        email,
      };
      const { resendMutation } = this.props;
      resendMutation({
        variables: { input },
      })
        .then(({ data }) => {
          const { resendFlatRateOfferBatch: { success, errors: resendErrors } } = data;
          if (success) {
            handleCloseHandler();
            flashMessageSuccess();
          } else {
            flashMessageFailure(resendErrors);
            handleCloseHandler();
          }
        })
        .catch(error => {
          flashMessageFailure(error);
          handleCloseHandler();
        });
      return true;
    };

    return (
      <Modal
        open={modalOpen}
        closeIcon
        onClose={handleCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>Resend Offer</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Form>
              <Form.Field>
                <label htmlFor='resendName'>Resend offer email to:</label>
                <input id='resendName' placeholder='Name' value={name} readOnly />
              </Form.Field>
              <Form.Field required error={!isEmpty(errors.email)}>
                <label htmlFor='resendEmail'>Email:</label>
                <input
                  id='resendEmail'
                  name='email'
                  value={email}
                  placeholder='email'
                  onChange={onChangeHandler('email')}
                />
                {errors.email && <span>{errors.email}</span>}
              </Form.Field>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button color='green' onClick={submitForm} inverted>
            <Icon name='checkmark' /> Okay
          </Button>
          <Button onClick={handleCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

ResendEmail.propTypes = {
  enrollmentStatus: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
  }),
  incompleteEnrollment: PropTypes.shape({
    flatRateOfferBatchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  flashMessageSuccess: PropTypes.func.isRequired,
  flashMessageFailure: PropTypes.func.isRequired,
  resendMutation: PropTypes.func.isRequired,
};

export default compose(
  graphql(resendFlatRateOfferBatchMutation, { name: 'resendMutation' })
)(ResendEmail);
